import { useRef } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import ServicesBento from "@/components/site/ServicesBento";
import BudgetGuide from "@/components/site/BudgetGuide";
import Pricing from "@/components/site/Pricing";
import Payments from "@/components/site/Payments";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingWhatsapp from "@/components/site/FloatingWhatsapp";
import "@/App.css";

function App() {
  const contactRef = useRef(null);

  const handleOrder = (serviceLabel) => {
    if (contactRef.current?.setService) {
      contactRef.current.setService(serviceLabel);
    }
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white font-body">
      <Navbar />
      <main>
        <Hero />
        <ServicesBento onOrder={handleOrder} />
        <BudgetGuide onOrder={handleOrder} />
        <Pricing onOrder={handleOrder} />
        <Payments />
        <Process />
        <Testimonials />
        <Contact ref={contactRef} />
      </main>
      <Footer />
      <FloatingWhatsapp />
    </div>
  );
}

export default App;
